/**
 * Computes a simple hash of a text string for change detection.
 * Uses a 32-bit hash algorithm for consistent results.
 */
export const computeTextHash = (text: string): string => {
  let h = 0;
  for (let i = 0; i < text.length; i++) {
    h = (h << 5) - h + text.charCodeAt(i);
    h |= 0; // Force 32-bit integer
  }
  return h.toString();
};
